import { http } from 'app/lib/axios';
import type { NewListingSource } from 'app/types/listing';

export interface SuggestedListing {
  id: string;
  isPriority?: boolean;
  listingGroup: {
    name: string | null;
    picture: string | null;
  };
}

export type SuggestedListingAnswer = 'yes' | 'no';

export async function getSuggestedListings(): Promise<SuggestedListing[]> {
  return (await http.get<SuggestedListing[]>('/listings/suggested')).data;
}

export interface SuggestedListingsWithCount {
  suggestions: SuggestedListing[];
  answeredCount?: number;
}

export async function getSuggestedListingsWithCount(): Promise<SuggestedListingsWithCount> {
  const { data } = await http.get<SuggestedListingsWithCount | SuggestedListing[]>('/listings/suggested', {
    params: { includeAnsweredCount: true },
  });
  // Older API deployments still return an array while the backend rolls out.
  return Array.isArray(data) ? { suggestions: data } : data;
}

export async function answerSuggestedListing(
  id: SuggestedListing['id'],
  answer: SuggestedListingAnswer,
  source: NewListingSource | undefined,
  signal: AbortSignal,
): Promise<void> {
  await http.post(`/listings/suggested/${id}/${answer}`, undefined, {
    signal,
    ...(source ? { params: { source } } : {}),
  });
}
